import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "src/app/Services/auth.service";
import * as alertify from "alertifyjs";
import {ActivatedRoute, Router} from "@angular/router";
import { Constant } from "src/app/Shared/Constant";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { LoginContext } from "src/app/Shared/login-context.model";
import { ToastrService } from "ngx-toastr";
import * as moment from "moment";
import { ViewDaAssessmentsComponent } from "../../Admin/assessments/direct-assessments/olive/view-da-assessments/view-da-assessments.component";
import { BsModalService } from "ngx-bootstrap/modal";
import { FirstTimePasswordChangeComponent } from "../first-time-password-change/first-time-password-change.component";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  form: any = FormGroup;
  userDetails: any;
  showPassword: boolean = false;

  recaptchaToken: string = "";
  login: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private bsModalService: BsModalService,
    private route: ActivatedRoute,
  ) {
    this.form = this.initializeForm();
  }
  ngOnInit(): void {
    localStorage.removeItem(Constant.USER_DATA);
    localStorage.removeItem(Constant.LOGGED_IN_USER);
    this.reCaptchaV3Service.execute("importantAction").subscribe((token) => {
      this.recaptchaToken = token;
    });
  }

  initializeForm() {
    return (this.form = this.fb.group({
      email: ["", [Validators.required]],
      password: ["", Validators.required],
      togglePassword: [null],
      recaptcha: [null],
    }));
  }

  get loginFormControl() {
    return this.form.controls;
  }

  togglePassword() {
    var passwordInput = document.getElementById("password") as HTMLInputElement;
    var togglePassword = this.form.controls["togglePassword"].value;

    if (togglePassword === true) {
      passwordInput.type = "text";
      this.showPassword = true;
    } else {
      passwordInput.type = "password";
      this.showPassword = false;
    }
  }

  getUrl(urls:string) : string {
    const url = this.route.snapshot.queryParamMap.get('returnUrl');
    return url ? url : urls;
  }

  LoginUser() {
    this.login = true;
    this.reCaptchaV3Service.execute("importantAction").subscribe((token) => {
      this.recaptchaToken = token;
    });
    this.form.patchValue({ recaptcha: this.recaptchaToken });

    if (this.form.value.recaptcha == null || this.form.value.recaptcha == "") {
      this.login = false;
      alertify.set("notifier", "position", "top-right");
      alertify.error("Please verify that you are not a robot");
      return;
    }
    // check if form is valid and if not, show validation errors and return
    if (this.form.invalid) {
      this.login = false;
      alertify.set("notifier", "position", "top-right");
      alertify.error("Please enter valid credentials");
      return;
    }

    // create login context
    const loginContext: any = {
      email: this.loginFormControl["email"].value,
      password: this.loginFormControl["password"].value,
    };

    // call login service
    this.authService.login(loginContext, true).subscribe({
      next: (response) => {
        if (response.token != null) {
          this.login = false;
          localStorage.setItem(Constant.LOGGED_IN_USER, response.token);
          localStorage.setItem(Constant.REFRESH_TOKEN, response.refreshToken);
          localStorage.setItem(
            Constant.SESSION_TIMER,
            JSON.stringify(
              moment(Date.now()).add(1, "hours").subtract(30, "minutes")
            )
          );
          this.authService.setUser(response);
          if (response.account == "AIRS") {
            if (this.authService.checkFirstLogin()) {
              let bsModalRef = this.bsModalService.show(
                FirstTimePasswordChangeComponent,
                {
                  class: "modal-md modal-dialog-centered",
                  ignoreBackdropClick: true,
                  backdrop: "static",
                  initialState: {
                    email: this.loginFormControl["email"].value,
                  },
                }
              );
              bsModalRef?.content?.onConfirmClicked.subscribe((v) => {
                bsModalRef.hide();
              });
            } else {
              this.router.navigate([this.getUrl("/admin")]);
              window.location.reload();
            }
          } else if (response.account == "MDA") {
            this.router.navigate([this.getUrl("/mda")]);
            window.location.reload();
          } else if (response.account == "TAMA") {
            this.router.navigate([this.getUrl("/user/tama")]);
            window.location.reload();
          } else if (response.account == "TAAS") {
            this.router.navigate([this.getUrl("/user/taas")]);
            window.location.reload();
          } else {
            this.router.navigate([this.getUrl("/user")]);
            window.location.reload();
          }
        } else {
          this.login = false;
          alertify.set("notifier", "position", "top-right");
          alertify.error(response.message);
        }
      },
      error: (error) => {
        this.login = false;
        let errorMessage = '';
        
        if (error instanceof HttpErrorResponse) {
          errorMessage = error.message;
        } else if (typeof error !== 'string') {
          errorMessage = JSON.stringify(error);
        } else {
          errorMessage = error;
        }

        // this.toastr.error(
        //   errorMessage || Constant.ERROR_OCCURED,
        //   "Error",
        //   {
        //     positionClass: "toast-top-center",
        //   }
        // );

        alertify.set("notifier", "position", "top-right");
        alertify.error(errorMessage || Constant.ERROR_OCCURED);
      },
    });
  }
}
